<template>
  <div>
    <!-- 使用公共导航栏组件 -->
    <Nav />

    <!-- 登录表单容器 -->
    <!-- 主要内容区 -->
    <div class="flex-1 flex items-center justify-center px-4 py-12 pt-20">
      <div class="w-full max-w-lg">
        <div class="mb-8">
          <div class="text-center">
            <h1 class="text-2xl font-bold text-gray-900 mb-2">用户登录</h1>
            <p class="text-gray-600 text-sm">欢迎回来，请登录您的账户</p>
          </div>
        </div>
        <div class="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
          <!-- 微信扫码登录 -->
          <div
            v-if="loginMethod === 'wechat'"
            class="flex flex-col items-center"
          >
            <div
              class="w-60 h-60 bg-gray-100 rounded-lg flex items-center justify-center mb-4 pt-60"
              id="login_container"
            ></div>
            <p class="text-sm text-gray-600 mb-6">请使用微信扫码登录</p>
            <p class="text-sm text-gray-600">
              Tip：未在会找我完成绑定的微信和手机号，是两个独立账号
            </p>
          </div>

          <!-- 手机号密码登录 -->
          <div v-else-if="loginMethod === 'password'" class="space-y-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >手机号
              </label>
              <div class="relative">
                <div
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center"
                >
                  <i class="ri-phone-line text-gray-400"></i>
                </div>
                <input
                  type="tel"
                  name="mobile"
                  id="mobile"
                  v-model="mobile"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >密码</label
              >
              <div class="relative">
                <div
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center"
                >
                  <i class="ri-lock-line text-gray-400"></i>
                </div>
                <input
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  v-model="password"
                  class="password-input w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入密码"
                />
                <button
                  type="button"
                  @click="togglePasswordVisibility"
                  class="password-toggle absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i v-if="showPassword" class="ri-eye-line"></i>
                  <i v-else class="ri-eye-off-line"></i>
                </button>
              </div>
            </div>
            <div class="flex items-center justify-between">
              <label class="flex items-center cursor-pointer">
                <!-- <div class="relative">
                  <input
                    type="checkbox"
                    name="remember"
                    class="sr-only"
                    v-model="rememberMe"
                  />
                  <div
                    class="checkbox-custom w-5 h-5 border-2 border-gray-300 rounded bg-white flex items-center justify-center transition-colors"
                    :class="{ 'bg-primary': rememberMe }"
                  >
                    <i
                      class="ri-check-line text-white text-sm"
                      v-if="rememberMe"
                    ></i>
                  </div>
                </div>
                <span class="ml-2 text-sm text-gray-600">记住我</span> -->
              </label>
              <a
                href="#"
                class="text-sm text-primary hover:text-secondary transition-colors"
                >忘记密码？</a
              >
            </div>
            <button
              type="button"
              @click="handlePasswordLogin"
              :disabled="loading"
              class="w-full bg-primary text-white py-3 !rounded-button hover:bg-secondary transition-colors text-base font-medium whitespace-nowrap flex items-center justify-center"
            >
              <span v-if="loading">登录中...</span>
              <span v-else>登录</span>
            </button>
          </div>

          <!-- 手机号验证码登录 -->
          <div v-else-if="loginMethod === 'code'" class="space-y-6">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >手机号
              </label>
              <div class="relative">
                <div
                  class="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 flex items-center justify-center"
                >
                  <i class="ri-phone-line text-gray-400"></i>
                </div>
                <input
                  type="tel"
                  name="mobile"
                  id="mobile"
                  v-model="mobile"
                  class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入手机号"
                />
              </div>
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-2"
                >验证码</label
              >
              <div class="flex space-x-3">
                <input
                  type="text"
                  v-model="code"
                  class="flex-1 pl-3 pr-4 py-3 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-primary focus:border-transparent transition-colors"
                  placeholder="请输入验证码"
                  maxlength="4"
                />
                <button
                  type="button"
                  @click="sendCode"
                  :disabled="countdown > 0 || loading"
                  class="whitespace-nowrap px-4 py-3 bg-primary text-white rounded-lg text-sm font-medium hover:bg-secondary transition-colors"
                >
                  {{
                    countdown > 0 ? `${countdown}秒后重新发送` : "发送验证码"
                  }}
                </button>
              </div>
            </div>
            <button
              type="button"
              @click="handleCodeLogin"
              :disabled="loading"
              class="w-full bg-primary text-white py-3 !rounded-button hover:bg-secondary transition-colors text-base font-medium whitespace-nowrap flex items-center justify-center"
            >
              <span v-if="loading">登录中...</span>
              <span v-else>登录</span>
            </button>
          </div>

          <div class="mt-8">
            <div class="relative">
              <div class="absolute inset-0 flex items-center">
                <div class="w-full border-t border-gray-200"></div>
              </div>
              <div class="relative flex justify-center text-sm">
                <span class="px-4 bg-white text-gray-500"
                  >或使用以下方式登录</span
                >
              </div>
            </div>

            <div class="mt-6 grid grid-cols-3 gap-3">
              <!-- 微信扫码登录 -->
              <button
                type="button"
                @click="loginMethod = 'wechat'"
                class="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-wechat-fill text-green-500"></i>
                </div>
                <span class="text-sm text-gray-700">微信</span>
              </button>
              <!-- 手机密码登录 -->
              <button
                type="button"
                @click="loginMethod = 'password'"
                class="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-lock-2-line text-blue-500"></i>
                </div>
                <span class="text-sm text-gray-700">密码登录</span>
              </button>
              <!-- 手机号验证码登录 -->
              <button
                type="button"
                @click="loginMethod = 'code'"
                class="flex items-center justify-center px-4 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <div class="w-5 h-5 flex items-center justify-center mr-2">
                  <i class="ri-phone-line text-gray-400"></i>
                </div>
                <span class="text-sm text-gray-700">验证码登录</span>
              </button>
            </div>
          </div>
          <!-- 底部注册提示 -->
          <div class="mt-6 text-center bg-gray-50 p-4 pb-8 rounded-md">
            <span class="text-sm text-gray-600 float-left mb-2">
              登录即同意
              <router-link
                to="/help/1"
                class="text-gray-600 hover:text-secondary transition-colors"
                >《用户协议》</router-link
              >
              和
              <router-link
                to="/help/2"
                class="text-gray-600 hover:text-secondary transition-colors"
                >《隐私政策》</router-link
              >
            </span>
            <router-link
              to="/register"
              class="text-sm text-primary hover:text-secondary transition-colors float-right"
              >手机号注册</router-link
            >
          </div>
        </div>
      </div>
    </div>

    <!-- 使用公共页脚组件 -->
    <Footer />
  </div>
</template>

<script>
import Nav from "@/components/Nav.vue";
import Footer from "@/components/Footer.vue";
import api from "@/utils/api.js";

export default {
  name: "Login",
  components: {
    Footer,
    Nav,
  },
  data() {
    return {
      loginMethod: "wechat", // 默认微信扫码登录
      mobile: "",
      password: "",
      code: "",
      rememberMe: false,
      loading: false,
      showPassword: false,
      countdown: 0,
      urlCheckTimer: null,
      timer: null,
    };
  },
  methods: {
    // 检查登录状态
    async checkLoginStatus() {
      try {
        // 使用store中的checkLoginStatus方法检查登录状态
        const isLoggedIn = await this.$store.dispatch("user/checkLoginStatus");

        if (isLoggedIn) {
          // 如果已登录，跳转到用户中心
          this.$message.info("您已登录，正在跳转到用户中心...");
          setTimeout(() => {
            this.$router.push("/ucenter/index");
          }, 1500);
        }
      } catch (error) {
        console.error("检查登录状态失败:", error);
        // 发生错误时，允许用户继续登录流程
      }
    },

    // 手机号密码登录
    async handlePasswordLogin() {
      if (!this.validatePasswordForm()) {
        return;
      }

      try {
        this.loading = true;
        // 使用store dispatch调用登录action
        const result = await this.$store.dispatch("user/login", {
          account: this.mobile,
          password: this.password,
          rememberMe: this.rememberMe,
        });

        // 登录成功后跳转
        const redirect = this.$route.query.redirect || "/ucenter/index";
        if (result) {
          setTimeout(() => {
            this.$router.push(redirect);
          }, 1500);
        }
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    // 手机号验证码登录
    async handleCodeLogin() {
      if (!this.validateCodeForm()) {
        return;
      }
      try {
        this.loading = true;
        // 使用store dispatch调用手机号登录action
        const result = await this.$store.dispatch("user/mobileLogin", {
          mobile: this.mobile,
          code: this.code,
          rememberMe: this.rememberMe,
        });

        // 登录成功后跳转
        const redirect = this.$route.query.redirect || "/ucenter/index";

        setTimeout(() => {
          this.$router.push(redirect);
        }, 1500);
      } catch (error) {
      } finally {
        this.loading = false;
      }
    },

    // 发送验证码
    async sendCode() {
      // 验证手机号
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!this.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return;
      }

      if (!mobileRegex.test(this.mobile)) {
        this.$message.warning("请输入有效的手机号");
        return;
      }

      try {
        // 调用发送验证码API
        const response = await api.code.send({
          mobile: this.mobile,
          event: "mobilelogin",
        });
        this.startCountdown();
      } catch (error) {
        this.$message.error("验证码发送失败，请重试");
      }
    },

    // 验证码倒计时
    startCountdown() {
      this.countdown = 60;
      // 先清除可能存在的定时器
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
        }
      }, 1000);
    },

    // 验证密码登录表单
    validatePasswordForm() {
      // 验证手机号
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!this.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return false;
      }

      if (!mobileRegex.test(this.mobile)) {
        this.$message.warning("请输入有效的手机号");
        return false;
      }

      // 验证密码
      if (!this.password) {
        this.$message.warning("请输入密码");
        return false;
      }

      if (this.password.length < 8) {
        this.$message.warning("密码长度至少为8位");
        return false;
      }

      return true;
    },

    // 验证验证码登录表单
    validateCodeForm() {
      // 验证手机号
      const mobileRegex = /^1[3-9]\d{9}$/;
      if (!this.mobile.trim()) {
        this.$message.warning("请输入手机号");
        return false;
      }

      if (!mobileRegex.test(this.mobile)) {
        this.$message.warning("请输入有效的手机号");
        return false;
      }

      // 验证验证码
      if (!this.code.trim()) {
        this.$message.warning("请输入验证码");
        return false;
      }

      if (this.code.length !== 4 || !/^\d+$/.test(this.code)) {
        this.$message.warning("验证码格式不正确");
        return false;
      }

      return true;
    },

    // 切换密码可见性
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    // 清理微信登录容器
    clearWechatContainer() {
      const container = document.getElementById("login_container");
      if (container) {
        // 清空容器内容，移除可能存在的iframe
        container.innerHTML = "";

        // 检查并移除之前引入的微信登录脚本
        const existingScript = document.getElementById("wx-login-script");
        if (existingScript) {
          existingScript.remove();
        }
      }
    },

    // 解析URL中的参数
    getUrlParams() {
      const url = window.location.href;
      const params = {};
      const regex = /[?&]([^=#]+)=([^&#]*)/g;
      let match;

      while ((match = regex.exec(url))) {
        params[decodeURIComponent(match[1])] = decodeURIComponent(match[2]);
      }

      return params;
    },

    // 检查URL中的code和state参数
    checkUrlForWechatParams() {
      const params = this.getUrlParams();

      // 如果URL中存在code和state参数
      if (params.code && params.state) {
        console.log("检测到微信登录回调参数:", params);

        // 清除定时器
        this.clearUrlCheckTimer();

        // 调用微信登录API
        this.handleWechatLogin(params.code, params.state);

        // 可选：清除URL中的参数，避免刷新页面重复登录
        // if (window.history.replaceState) {
        //   const cleanUrl =
        //     window.location.origin +
        //     window.location.pathname +
        //     window.location.hash.split("?")[0];
        //   window.history.replaceState({}, document.title, cleanUrl);
        // }
      }
    },

    // 启动URL参数检查定时器
    startUrlCheckTimer() {
      // 先清除之前可能存在的定时器
      this.clearUrlCheckTimer();

      // 设置新的定时器，每秒检查一次URL
      this.urlCheckTimer = setInterval(() => {
        this.checkUrlForWechatParams();
      }, 1000);
    },

    // 清除URL参数检查定时器
    clearUrlCheckTimer() {
      if (this.urlCheckTimer) {
        clearInterval(this.urlCheckTimer);
        this.urlCheckTimer = null;
      }
    },

    // 处理微信登录
    async handleWechatLogin(code, state) {
      try {
        // 显示加载状态
        this.loading = true;

        // 调用微信登录API
        const result = await this.$store.dispatch("user/wechatLogin", {
          code: code,
          state: state,
        });


       // 登录成功后跳转
        const redirect = this.$route.query.redirect || "/ucenter/index";

        setTimeout(() => {
          this.$router.push(redirect);
        }, 1500);

      } catch (error) {
        console.error("微信登录失败:", error);
      } finally {
        this.loading = false;
      }
    },

    // get_wx_qrcode
    async getWxQrcode() {
      // 先清理之前的二维码内容
      this.clearWechatContainer();

      // 动态引入微信登录JS文件
      const script = document.createElement("script");
      script.id = "wx-login-script";
      script.src =
        "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js";
      script.onload = () => {
        this.$nextTick(() => {
          const url = encodeURIComponent("https://www.huizhaowo.com/#/login"); // 你要重定向的页面地址
          // 创建实例对象
          let obj = new WxLogin({
            self_redirect: false,
            id: "login_container",
            appid: "wx06bafce6d9dd76a6",
            scope: "snsapi_login",
            redirect_uri: url, // 重定向的地址
            state: "huizhaowo",
            style: "",
            href: "",
            stylelite: 1,
            onReady: function (isReady) {
              // iframe页面是否加载成功的回调，isReady为true表示加载成功
              console.log("onReady>>>", isReady);
            },
          });
        });
      };
      document.body.appendChild(script);
    },
  },
  // 监听登录方式变化
  watch: {
    loginMethod(newMethod, oldMethod) {
      // 当从其他登录方式切换到微信登录时，重新加载二维码
      if (newMethod === "wechat") {
        this.$nextTick(() => {
          this.getWxQrcode();
        });
      } else if (oldMethod === "wechat") {
        // 当从微信登录切换到其他方式时，清理容器
        this.clearWechatContainer();
      }
    },
  },
  mounted() {
    // 进入登录页时检查登录状态
    // this.checkLoginStatus();
    // 如果默认登录方式是微信登录，则获取二维码
    if (this.loginMethod === "wechat") {
      this.getWxQrcode();
    }

    // 检查URL中是否已经有微信登录回调参数
    this.checkUrlForWechatParams();

    // 启动URL参数检查定时器
    this.startUrlCheckTimer();
  },
  beforeDestroy() {
    // 清除验证码倒计时定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
    // 清除URL参数检查定时器
    this.clearUrlCheckTimer();
  },
};
</script>

<style scoped>
/**/
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue